var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReultDeskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reult-deskIcon",
    transform: "translate(-184.003 -509.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "free-icon-exclamation-mark-179386",
    transform: "translate(184.003 509.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11754",
    "data-name": "\\uD328\\uC2A4 11754",
    d: "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,45.312A20.312,20.312,0,1,1,45.312,25,20.312,20.312,0,0,1,25,45.312Z",
    fill: "#16b560"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17550",
    "data-name": "\\uD328\\uC2A4 17550",
    d: "M651,1179.136l-15.258,14.58-5.276-5.041a1.987,1.987,0,0,0-1.387-.55h-.021a1.978,1.978,0,0,0-1.392.577,1.905,1.905,0,0,0,.023,2.734l6.665,6.363a2.072,2.072,0,0,0,2.774,0l16.65-15.909a1.887,1.887,0,0,0,.025-2.689A2.021,2.021,0,0,0,651,1179.136Z",
    transform: "translate(-431.733 -653.463)",
    fill: "#16b560"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReultDeskIcon);
export default __webpack_public_path__ + "static/media/reult-deskIcon.69dff4608f3430dffab25ef13df77be7.svg";
export { ForwardRef as ReactComponent };